/**
 * Side-effect module that arms diagnostics.
 *
 * This lives in its own module, and must be imported FIRST in index.tsx, because ES
 * module imports are evaluated before the importing module's body. Calling these from
 * index.tsx directly would run them *after* every other import — including the Redux
 * store and its epics — leaving the riskiest bootstrap code unreported.
 *
 * The log buffer is installed before crash reporting, since it is the breadcrumb
 * source for the reports.
 */
import { initCrashlytics } from './services/crashlytics/crashlyticsService'
import { installLogBuffer } from './services/logger/logBuffer'

installLogBuffer()
void initCrashlytics()
